import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGB = function FlagGB() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#0052B4",
    d: "M5.167 9.78A24.909 24.909 0 0 0 .86 18.477h13.006L5.167 9.78ZM49.14 18.478a24.91 24.91 0 0 0-4.308-8.699l-8.698 8.7h13.005ZM.86 31.521a24.912 24.912 0 0 0 4.307 8.7l8.699-8.7H.86ZM40.22 5.168A24.91 24.91 0 0 0 31.521.86v13.006l8.7-8.7ZM9.778 44.832a24.91 24.91 0 0 0 8.699 4.306V36.133l-8.699 8.699ZM18.477.861a24.912 24.912 0 0 0-8.699 4.307l8.699 8.699V.86ZM31.521 49.139a24.911 24.911 0 0 0 8.7-4.307l-8.7-8.699v13.005ZM36.134 31.521l8.698 8.7a24.909 24.909 0 0 0 4.307-8.7H36.134Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M49.788 21.74H28.261V.211a25.248 25.248 0 0 0-6.522 0v21.527H.212a25.248 25.248 0 0 0 0 6.522h21.527v21.527a25.257 25.257 0 0 0 6.522 0V28.261h21.527a25.257 25.257 0 0 0 0-6.522Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "m31.521 31.522 11.156 11.156a25.052 25.052 0 0 0 1.47-1.605l-9.551-9.551H31.52ZM18.477 31.522 7.32 42.678c.513.513 1.05 1.002 1.605 1.47l9.551-9.552v-3.074ZM18.48 18.479 7.322 7.321a25.063 25.063 0 0 0-1.47 1.605l9.552 9.551h3.074ZM31.521 18.478 42.677 7.322a25.025 25.025 0 0 0-1.605-1.47l-9.55 9.552v3.074Z"
  }));
};
FlagGB.displayName = 'FlagGB';
export default withFlagWrapper(FlagGB);
//# sourceMappingURL=index.js.map